import { render } from "./AppLogoDoacao.vue?vue&type=template&id=7a1b2f32&scoped=true"
import script from "./AppLogoDoacao.vue?vue&type=script&lang=js"
export * from "./AppLogoDoacao.vue?vue&type=script&lang=js"

import "./AppLogoDoacao.vue?vue&type=style&index=0&id=7a1b2f32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1b2f32"]])

export default __exports__